import React from 'react';
import LandingLayout from '../layouts/LandingLayout';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import VideoSection from '../components/VideoSection';
import FaqSection from '../components/FaqSection';

const LandingPage: React.FC = () => {
  return (
    <LandingLayout>
      <HeroSection />
      <ServicesSection />
      <VideoSection />
      <FaqSection />
    </LandingLayout>
  );
};

export default LandingPage;
